var _path, _g, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlockedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outside",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0204 0.386232C99.9915 -0.12972 106.008 -0.129721 111.98 0.38623C114.181 0.576408 115.811 2.51479 115.62 4.71573C115.43 6.91667 113.492 8.54671 111.291 8.35653C105.778 7.88016 100.222 7.88016 94.7091 8.35653C92.5082 8.54671 90.5698 6.91667 90.3796 4.71573C90.1894 2.51479 91.8195 0.57641 94.0204 0.386232ZM64.7746 11.5614C65.7096 13.563 64.8449 15.9434 62.8434 16.8784C57.8102 19.2294 53.0164 22.0092 48.509 25.1711C46.7005 26.4398 44.2059 26.0021 42.9372 24.1936C41.6686 22.3851 42.1062 19.8905 43.9147 18.6218C48.8006 15.1945 53.9984 12.1802 59.4576 9.63015C61.4592 8.69521 63.8397 9.55986 64.7746 11.5614ZM141.225 11.5614C142.16 9.55986 144.541 8.69521 146.542 9.63015C152.002 12.1802 157.199 15.1945 162.085 18.6218C163.894 19.8905 164.331 22.3851 163.063 24.1936C161.794 26.0021 159.3 26.4398 157.491 25.1711C152.984 22.0092 148.19 19.2294 143.157 16.8784C141.155 15.9434 140.29 13.563 141.225 11.5614ZM24.1936 42.9372C26.0021 44.2059 26.4398 46.7004 25.1711 48.509C22.0092 53.0163 19.2295 57.8102 16.8784 62.8434C15.9435 64.8449 13.563 65.7096 11.5614 64.7746C9.55987 63.8397 8.69522 61.4592 9.63016 59.4576C12.1802 53.9984 15.1945 48.8005 18.6218 43.9147C19.8905 42.1062 22.3851 41.6686 24.1936 42.9372ZM181.806 42.9372C183.615 41.6686 186.109 42.1062 187.378 43.9147C190.806 48.8005 193.82 53.9984 196.37 59.4576C197.305 61.4592 196.44 63.8397 194.439 64.7746C192.437 65.7096 190.057 64.8449 189.122 62.8434C186.771 57.8102 183.991 53.0163 180.829 48.509C179.56 46.7004 179.998 44.2059 181.806 42.9372ZM201.284 90.3796C203.485 90.1894 205.424 91.8195 205.614 94.0204C205.87 96.9805 206 99.9755 206 103C206 106.024 205.87 109.02 205.614 111.98C205.424 114.18 203.485 115.811 201.284 115.62C199.083 115.43 197.453 113.492 197.643 111.291C197.879 108.56 198 105.794 198 103C198 100.206 197.879 97.4404 197.643 94.7091C197.453 92.5081 199.083 90.5698 201.284 90.3796ZM4.71574 90.3796C6.91668 90.5698 8.54672 92.5082 8.35654 94.7091C8.12054 97.4404 8 100.206 8 103C8 105.794 8.12054 108.56 8.35654 111.291C8.54672 113.492 6.91668 115.43 4.71574 115.62C2.5148 115.811 0.576421 114.181 0.386243 111.98C0.130471 109.02 0 106.025 0 103C0 99.9755 0.130471 96.9805 0.386242 94.0204C0.576419 91.8195 2.5148 90.1894 4.71574 90.3796ZM11.5614 141.225C13.563 140.29 15.9435 141.155 16.8784 143.157C19.2295 148.19 22.0092 152.984 25.1711 157.491C26.4398 159.3 26.0021 161.794 24.1936 163.063C22.3851 164.331 19.8905 163.894 18.6218 162.085C15.1945 157.199 12.1802 152.002 9.63016 146.542C8.69522 144.541 9.55987 142.16 11.5614 141.225ZM194.439 141.225C196.44 142.16 197.305 144.541 196.37 146.542C193.82 152.002 190.806 157.199 187.378 162.085C186.109 163.894 183.615 164.331 181.806 163.063C179.998 161.794 179.56 159.3 180.829 157.491C183.991 152.984 186.771 148.19 189.122 143.157C190.057 141.155 192.437 140.29 194.439 141.225ZM42.9372 181.806C44.2059 179.998 46.7005 179.56 48.509 180.829C53.0164 183.991 57.8102 186.771 62.8434 189.122C64.8449 190.057 65.7096 192.437 64.7746 194.439C63.8397 196.44 61.4592 197.305 59.4576 196.37C53.9984 193.82 48.8006 190.805 43.9147 187.378C42.1062 186.109 41.6686 183.615 42.9372 181.806ZM163.063 181.806C164.331 183.615 163.894 186.109 162.085 187.378C157.199 190.805 152.002 193.82 146.542 196.37C144.541 197.305 142.16 196.44 141.225 194.439C140.29 192.437 141.155 190.057 143.157 189.122C148.19 186.771 152.984 183.991 157.491 180.829C159.3 179.56 161.794 179.998 163.063 181.806ZM90.3796 201.284C90.5698 199.083 92.5082 197.453 94.7091 197.643C100.222 198.12 105.778 198.12 111.291 197.643C113.492 197.453 115.43 199.083 115.62 201.284C115.811 203.485 114.181 205.424 111.98 205.614C106.008 206.13 99.9916 206.13 94.0204 205.614C91.8195 205.424 90.1894 203.485 90.3796 201.284Z",
    fill: "#21BB71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 79.2,
    fill: "#21BB71"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 79.2,
    transform: "matrix(-1 0 0 1 103 103)",
    fill: "#21BB71"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 71.0471,
    fill: "#21BB71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7212 140.234C72.9623 148.508 86.8684 154.107 102.833 154.107C118.767 154.107 132.65 148.481 139.903 140.233L65.7212 140.234Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2687 140.107C70.9333 133.657 74.3706 125.184 74.3706 115.902C74.3706 102.165 66.8416 90.1964 55.707 83.9434",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0861 140.232C89.8165 133.767 93.2988 125.244 93.2988 115.902C93.2988 102.165 85.7695 90.1963 74.6353 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8965 91.2621C67.5332 88.3541 70.6299 85.8756 74.0714 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5728 140.232C77.8429 133.767 74.3604 125.243 74.3604 115.901C74.3604 102.164 81.8894 90.1962 93.0239 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.071 140.232C108.801 133.767 112.283 125.244 112.283 115.901C112.283 102.165 104.754 90.1964 93.6191 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.557 140.233C96.8263 133.768 93.3442 125.244 93.3442 115.901C93.3442 102.164 100.873 90.1962 112.008 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.999 140.232C127.729 133.767 131.211 125.243 131.211 115.901C131.211 102.164 123.682 90.1962 112.547 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.484 140.231C115.754 133.767 112.272 125.243 112.272 115.901C112.272 102.164 119.802 90.1962 130.936 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.735 91.2943C138.092 88.3725 134.985 85.8827 131.531 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.301 140.105C134.638 133.656 131.201 125.182 131.201 115.901C131.201 102.164 138.73 90.1962 149.865 83.9431",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9819 83.9204C55.9819 83.9204 66.7179 63.6151 86.1363 63.9284C86.1363 63.9284 95.95 63.9284 100.372 68.6151V48.1565H105.262V68.6151C109.684 63.9284 119.498 63.9284 119.498 63.9284C138.917 63.6151 149.652 83.9204 149.652 83.9204H55.9819Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.607,
    cy: 68.3335,
    r: 5.82353,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 19.7998,
    y: 23.8,
    width: 166.4,
    height: 166.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedLogo);
export default __webpack_public_path__ + "static/media/unlocked_logo.21dbfa16.svg";
export { ForwardRef as ReactComponent };